import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';

@Component({
    selector: 'pim-sort',
    templateUrl: './sort.component.html',
    styleUrls: ['./sort.component.sass'],
    standalone: false
})
export class SortComponent implements OnChanges {
	@Input()
	name: string = '';

	@Input()
	sortColumn: string = '';

	@Input()
	sortOrder: boolean = false;

	@Output()
	sort: EventEmitter<any> = new EventEmitter<any>();

	active: boolean = true;

	constructor() {
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.active = this.name === this.sortColumn;
	}

	clicked(): void {
		this.sort.emit(this.name);
	}
}
